import React, { useEffect, useRef } from 'react';
import { useForm } from 'react-hook-form';
import { useSelector } from 'react-redux';
import { CustomInput2 } from '../customInput/CustomInput2';

export const ActiveSearch2 = ({
  searchSchema,
  onFiltersChange,
  className,
  disabled
}) => {
  const selectListOptions = useSelector(
    data => data.commonData.lista.formationPlaces
  );

  const { register, watch, reset } = useForm();
  const filters = watch();
  const prevFilters = useRef(filters);

  // 🔹 Emitir filtros SOLO si cambian de verdad
  useEffect(() => {
    const changed =
      JSON.stringify(prevFilters.current) !== JSON.stringify(filters);

    if (changed) {
      prevFilters.current = filters;
      onFiltersChange(filters);
    }
  }, [filters, onFiltersChange]);

  const onClean = () => reset({});


  //! Se cambia de "form" a "div" para evitar enviar el formulario apretando enter

  return (
    <div className="aSearch-container">
      {searchSchema.map(field => {
        if (field.select) {
          return (
            <select
              key={field.name}
              {...register(field.name)}
              className="form-select"
              defaultValue=""
            >
              <option value="">Seleccionar</option>
              {selectListOptions.map(opt => (
                <option key={opt.id} value={opt.id}>
                  {opt.name}
                </option>
              ))}
            </select>
          );
        }

        return (
          <CustomInput2
            disabled={disabled}
            key={field.name}
            register={register}
            name={field.name}
            placeholder={field.labelTitle}
            className={className}
            value={filters}
            resetField={() => reset({ [field.name]: "" })}
          />
        );
      })}
    </div>
  );
};
